import { createEnum } from "@redotech/zod-util/zod-enum";

export const workflowTypes = [
  "returnCreationSideEffects",
  "returnProcessSideEffects",
  "postReturnProcessSideEffects",
  "returnReadySideEffects",
  "postReturnReadySideEffects",
  "exchangeConversionWorkflow",
  "removeTeam",
  "exportShopifyReturn",
  "customsCorrectionSideEffects",
  "resetReturn",
  "flagReturn",
  "addTagToReturn",
  "rejectReturn",
  "processReturn",
] as const;

export type WorkflowType = (typeof workflowTypes)[number];

export const WorkflowTypeSchema = createEnum(workflowTypes);
